<template>
  <div
    :class="[isActive ? backgroundColorClass(blok.bgVariant) : '']"
    class="background-wrapper"
  >
    <slot />
  </div>
</template>

<script setup>
import { useColorPalette } from '../composables/colorPalette'

defineProps({
  blok: {
    type: Object,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: true,
  },
})

const { backgroundColorClass } = useColorPalette()
</script>
